import { localized } from '@/i18n/localize'
export const payRentStrings = localized({
  titleLandlord: 'Record a payment',
  titleTenant: 'Pay rent',
  pickLease: 'Which lease?',
  noLeases: 'No active leases found',
  upToDate: 'Up to date',
  due: 'Due',
  amountLabel: 'How much?',
  quickFullRent: 'Full rent',
  quickDue: 'Everything due',
  paysAhead: (amount: string) => `Only ${amount} is due now — the rest goes towards the months ahead.`,
  nothingDue: 'Nothing is outstanding on this lease right now.',
  methodLabel: 'How was it paid?',
  // Tenant-facing: says what they can still do, not "record a payment you received".
  // The app's wording since LP-479: whether online payment is allowed follows the lease's property, not the payer.
  onlineNotInCountry: "Online payment isn't available for this property yet. You can still pay your landlord directly.",
  methodCash: 'Cash or bank transfer',
  methodCashDescription: 'Recorded now, nothing is charged here.',
  methodUpiDescription: 'Pay from any UPI app.',
  methodOnlineDescription: 'Card, net banking or wallet.',
  noteLabel: 'Note (optional)',
  noteHint: 'e.g. paid in two parts',
  review: 'Review',
  confirmTitle: 'Confirm this payment',
  confirm: 'Confirm',
  cancel: 'Cancel',
  paidBy: 'Paid by',
  rent: 'Rent',
  gstOnRent: 'GST on rent',
  gatewayFee: 'Gateway fee',
  platformFee: 'Platform fee',
  method: 'Method',
  note: 'Note',
  youPay: 'You pay',
  total: 'Total',
  property: 'Property',
  paidOn: 'Paid on',
  successTitleLandlord: 'Payment recorded',
  successTitleTenant: 'Payment sent',
  successOffline: (name: string) => `${name} will see it straight away.`,
  successPendingLandlord: 'Your landlord will confirm it shortly.',
  successSent: 'Your landlord has been notified.',
  awaitingConfirmation: 'Awaiting confirmation · no receipt until your landlord accepts it',
  leaseEndedTitle: 'This lease has ended',
  leaseEndedDescription: 'Rent can only be paid on an active lease.',
  leaseNotActiveTitle: 'This lease is not active yet',
  leaseNotActiveDescription: 'Rent can be paid once the lease is active.',
  done: 'Done',
  recordAnother: 'Record another',
  shareReceipt: 'Share Receipt',
  receiptCopied: 'Receipt copied.',
  receiptNote: 'Generated by LeazePro',
  cashPendingNote: 'This payment will be marked as pending until the landlord confirms receipt.',
  onlineComingSoon: 'Online payments are coming soon',
  onlineUnavailable: "Online payment unavailable — landlord hasn't set up banking yet",
  upiComingSoon: 'UPI direct payments are coming soon',
  upiUnavailable: "UPI payment unavailable — landlord hasn't added a UPI address yet",
  paymentFailed: 'Payment Failed',
  somethingWentWrong: 'Something went wrong',
  periodsTitle: 'Unpaid rent',
  periodsHint: 'Payments clear the oldest rent first. Tick a month to pay up to it.',
  periodsNone: 'No unpaid rent on this lease.',
  periodsCaption: 'Unpaid rent periods, oldest first',
  colPeriod: 'Period',
  colAmount: 'Amount',
  colStatus: 'Status',
  partly: 'Part',
  payUpTo: (month: string) => `Pay up to ${month}`,
  summaryTitle: 'Summary',
  submitRecord: (amount: string) => `Record ${amount}`,
  submitPay: (amount: string) => `Pay ${amount}`,
  changeLease: 'Change',
  upiTitle: 'Pay via UPI',
  upiScan: 'Scan with any UPI app',
  upiOpenApp: 'Open UPI app',
  upiVpa: 'UPI ID',
  upiAmount: 'Amount',
  upiPayee: 'Paying to',
  upiCopy: 'Copy',
  upiCopied: 'Copied.',
  upiConfirmTitle: 'Did you complete the payment?',
  upiConfirmMessage: 'If you paid successfully, tap Confirm. Your landlord will verify and approve the payment.',
  upiConfirmButton: 'Yes, I Paid',
  upiCancelButton: 'No, Cancel',
  upiLaunchError: 'Could not open a UPI app. Please scan the QR code instead.',
  frequencyShort: { daily: '/ day', weekly: '/ week', monthly: '/ month', annually: '/ year' } as Record<string, string>,
})
